export function convertToLacCrore(n: number, decimals: number = 2) {
  if (n >= 1e7) {
    return (n / 1e7).toFixed(decimals) + " Cr";
  } else if (n >= 1e5) {
    return (n / 1e5).toFixed(decimals) + " Lac";
  } else if (n >= 1e3) {
    return (n).toFixed(0);
  } else {
    return n.toString();
  }
}

export function formatCurrency(
  amount: number,
  roundTo: number = 1,
  decimals: number = 2,
  currencyCode = "INR",
  locale = "en-in"
) {
  const val = Math.round(amount / roundTo) * roundTo;
  return new Intl.NumberFormat(locale, {
    style: "currency",
    currency: currencyCode,
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  }).format(val);
}
